import useSWR from "swr";

import { jsonFetch } from "lib/fetcher";

const urls = {
  getCountriesUrl(baseline) {
    return `${process.env.REACT_APP_API_URL}/api/timeline/countries?baseline=${baseline}`;
  },
  getSingleCountryUrl(country, baseline) {
    return `${process.env.REACT_APP_API_URL}/api/timeline/countries?baseline=${baseline}&countries=${country}`;
  },
  getSingleStateUrl(country, state, baseline) {
    return `${process.env.REACT_APP_API_URL}/api/timeline/states?baseline=${baseline}&country=${country}&states=${state}`;
  }
};


export function useSingleStateTimeline(country, state, baseline) {
  return useSWR(urls.getSingleStateUrl(country, state, baseline), jsonFetch)
}

export function useSingleCountryTimeline(country, baseline) {
  return useSWR(urls.getSingleCountryUrl(country, baseline), jsonFetch)
}

export function useCountriesTimeline(baseline) {
  return useSWR(urls.getCountriesUrl(baseline), jsonFetch)
}
